<template>
    <div>
        <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center no-padding-bottom">
            <span class="mask bg-gradient-danger opacity-8"></span>
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col-xl-12 order-xl-1">
                    <br><br><br>
                    <card shadow type="secondary">
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">

                                <div class="col-8">
                                    <h3 class="mb-0 text-uppercase" v-html="title"></h3>
                                    <br>
                                    <span class="text-danger" v-html="description"></span>
                                </div>
                                <div class="col-4 text-right">
                                    <router-link
                                        to="/verification-payment"
                                        class="btn btn-danger"
                                    >
                                        <i class="fa fa-reply"></i>
                                        Back
                                    </router-link>
                                </div>
                            </div>
                        </div>

                        <div v-if="! submitted || editApplication">
                            <!-- this is hospital's profile template -->
                            <ProfileData
                                :id="application.id"
                                :data="application"
                                :transaction="application.transaction"
                                :loadHospitalInfo="loadHospitalInfo"
                                :displayConsultantData="displayConsultantData"
                                v-if="showProfileData && application && application.training_hospital && ! isLoadingBlade"
                            />

                            <!-- this is hospital's Consultants template -->
                            <ConsultantData
                                :id="application.id"
                                :application="application"
                                :dept="departments"
                                :loadHospitalInfo="loadHospitalInfo"
                                :displayProfileData="displayProfileData"
                                :displayNursesData="displayNursesData"
                                v-if="showConsultantData && application && application.training_hospital
                                        && application.training_hospital.doctors && ! isLoadingBlade"
                            />

                            <!-- this is hospital's Nurses template -->
                            <NursesData
                                :id="application.id"
                                :application="application"
                                :loadHospitalInfo="loadHospitalInfo"
                                :displayConsultantData="displayConsultantData"
                                :displayStaffData="displayStaffData"
                                v-if="showNursesData && application && application.training_hospital
                                        && application.training_hospital.nurses && ! isLoadingBlade"
                            />

                            <!-- this is hospital's Staff template -->
                            <StaffData
                                :id="application.id"
                                :application="application"
                                :dept="departments"
                                :loadHospitalInfo="loadHospitalInfo"
                                :displayNursesData="displayNursesData"
                                :displayFacilityData="displayFacilityData"
                                v-if="showStaffData && application && application.training_hospital
                                        && application.training_hospital.staff && ! isLoadingBlade"
                            />

                            <!-- this is hospital's facility template -->
                            <FacilityData
                                :id="application.id"
                                :application="application"
                                :loadHospitalInfo="loadHospitalInfo"
                                :displayStaffData="displayStaffData"
                                :displaySummary="displaySummary"
                                v-if="showFacilityData && application && application.training_hospital
                                        && application.training_hospital.facilities && ! isLoadingBlade"
                            />

                            <!-- this is application summary template -->
                            <VerificationSummary
                                :id="application.id"
                                :application="application"
                                :loadHospitalInfo="loadHospitalInfo"
                                :displayFacilityData="displayFacilityData"
                                v-if="showSummary && application && ! isLoadingBlade"
                            />

                            <div class="col-lg-12" v-if="isLoadingBlade">
                                <div class="d-flex justify-content-center">
                                    <img :src="loadingBladeUrl" />
                                </div>
                            </div>

                            <div class="col-lg-12 text-center" v-if='showErrorStatus && ! isLoadingBlade'>
                                <base-alert :type="errorType">
                                    <!-- <span class="alert-inner--icon"><i class="ni ni-like-2"></i></span> -->
                                    <span class="alert-inner--text">
                                        <h2 class="text-white">{{errorMsg}}</h2>
                                    </span>
                                </base-alert>
                            </div>
                        </div>
                    </card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import ProfileData from './ProfileData';
    import ConsultantData from './ConsultantData';
    import NursesData from './NursesData';
    import StaffData from './StaffData';
    import FacilityData from './FacilityData';
    import VerificationSummary from './VerificationSummary/VerificationSummary';
    import swal from 'sweetalert2';// import sweet alert

    export default {
        name: 'ApplicationForm',
        components: {
            ProfileData,
            ConsultantData,
            NursesData,
            StaffData,
            FacilityData,
            VerificationSummary
        },
        data() {
            return {
                application: null,
                showErrorStatus: false,
                errorType: null,
                errorMsg: null,
                isLoadingBlade: true,
                showProfileData: true,
                showConsultantData: false,
                showNursesData: false,
                showStaffData: false,
                showFacilityData: false,
                showSummary: false,
                code: this.$route.name,
                title: null,
                description: null,
                editApplication: false,
                departments: []
            }
        },
        computed: {
            ...mapGetters(['websiteUrl', 'locations', 'loadingBladeUrl']),
            submitted() {
                return this.hospital && (this.hospital.status == 'submitted' || this.hospital.status == 'approved'
                    || this.hospital.status == 'rejected');
            }
        },
        methods: {
            ...mapActions(['getPendingApplication']),
            editAssessmentApp() {
                return this.editApplication = true;
            },
            loadTitle() {// load title
                return this.title = this.replaceString(this.code);
            },
            replaceString(value) {
                return value ? value.replace('-', ' ') : 'Accreditation Application';
            },
            changeTitle(value, des, status) {// change title
                let description = des ? des : 'Kindly fill the form below with correct information...';
                if(status) {
                    this.title = value;
                    this.description = description;
                } else {
                    this.loadTitle();
                }
            },
            loadHospitalInfo() {
                this.isLoadingBlade = true;
                this.application = null;
                this.getPendingApplication().then((res) => {
                    this.isLoadingBlade = false;
                    if(res.status) {
                        this.loadTitle();
                        this.application = res.application;
                        this.departments = res.departments;
                        if(! res.application) {
                            return window.location.href = '/';
                        }
                    } else {
                        let msg = 'Payment has not been made, proceed to make payment'
                        swal.fire("Payment Failed!", msg, "warning");
                        setTimeout(function() { window.location.href = '/verification-generate'; }, 5000);
                    }
                }).
                catch(() => {
                    this.showErrorStatus = true;
                    this.isLoadingBlade = false;
                    this.errorMsg = "Network Failure!, kindly reload the page...";
                    this.errorType = 'danger';
                });
            },
            displayProfileData(value) {
                this.showProfileData = value;
                this.showConsultantData = ! value;
                this.showNursesData = ! value;
                this.showStaffData = ! value;
                this.showSummary = ! value;
                this.showFacilityData = ! value;
            },
            displayConsultantData(value) {
                this.showProfileData = ! value;
                this.showNursesData = ! value;
                this.showStaffData = ! value;
                this.showFacilityData = ! value;
                this.showSummary = ! value;
                this.showConsultantData = value;
            },
            displayNursesData(value) {
                this.showProfileData = ! value;
                this.showConsultantData = ! value;
                this.showStaffData = ! value;
                this.showFacilityData = ! value;
                this.showSummary = ! value;
                this.showNursesData = value;
            },
            displayStaffData(value) {
                this.showProfileData = ! value;
                this.showConsultantData = ! value;
                this.showNursesData = ! value;
                this.showFacilityData = ! value;
                this.showSummary = ! value;
                this.showStaffData = value;
            },
            displayFacilityData(value) {
                this.showProfileData = ! value;
                this.showConsultantData = ! value;
                this.showNursesData = ! value;
                this.showStaffData = ! value;
                this.showSummary = ! value;
                this.showFacilityData = value;
            },
            displaySummary(value) {
                this.showProfileData = ! value;
                this.showConsultantData = ! value;
                this.showNursesData = ! value;
                this.showStaffData = ! value;
                this.showFacilityData = ! value;
                this.showSummary = value;
            }
        },
        created() {
            this.loadHospitalInfo();
        }
    }
</script>

<style scoped>
    .no-padding-bottom {
        padding-bottom: 0rem !important
    }
    .right {
        float: right;
    }
</style>

<style>
    .form-control-label {
        width: 100%;
    }
    .height-50 {
        height: 50px;
    }
    .borderLine {
        border: 1px solid #ededed;
    }
</style>